import Grid from "@material-ui/core/Grid"
import React, { Fragment } from "react"
import Typography from "@material-ui/core/Typography"
import IconButton from "@material-ui/core/IconButton"
import DeleteIcon from "@material-ui/icons/Delete"
import Visibility from "@material-ui/icons/Visibility"
import CloudDownload from "@material-ui/icons/CloudDownload"
import CircularProgress from "@material-ui/core/CircularProgress"
import { useDownload } from "./hooks/upload"
import { useAnnexItemStyles } from "./styles"
import { useMouseGesture } from "Hooks/basic"

interface ComponentProps {
    content_type: string,
    name: string,
    status?: string,
    url?: string,
    file_size: number,
    uploaded: boolean,
    disabled?: boolean,
    isUploading: boolean,
    material_id?: number,
    id?: number,
    percent?: number,
    onRemove: () => void,
}
interface AnnexIcon {
    image: string,
    audio: string,
    video: string,
    unknown: string,
    text: string,
    ppt: string,
    css: string,
    doc: string,
    msword: string,
    "vnd.openxmlformats-officedocument.presentationml.presentation": string,
    "vnd.openxmlformats-officedocument.spreadsheetml.sheet": string,
    excel: string,
    pdf: string,
}

const annexIconUrl: AnnexIcon = {
    image: "http://3-im.guokr.com/tnfM0-4QRiHsJK5Hrx9bDPoYwK_q4N3MZNoPfpphQ3PIAAAAyAAAAFBO.png",
    audio: "http://1-im.guokr.com/D8UEE2UgiMchodDCjV_iuZ17yIp2hvLq4wUNofDdDmHIAAAAyAAAAFBO.png",
    video: "http://1-im.guokr.com/zKNKRd5VxFBpDBsrXv-frGouyBL5hIaqL_m_iZGTMOnIAAAAyAAAAFBO.png",
    unknown: "http://2-im.guokr.com/Bfn5BL3Sbu8bIE24i9liev6Qi8oxwNQzj4T-ZmnH7crIAAAAyAAAAFBO.png",
    text: "http://2-im.guokr.com/22a6ChQep2ll5FkOuLJ_HOK4Qtgx5FrbvPiHP4OYCkbIAAAAyAAAAFBO.png",
    ppt: "http://3-im.guokr.com/WVgOu_1nP8-MnaEufdH3IF1Z3bDygLsC3kE7mYO0y9XIAAAAyAAAAFBO.png",
    "vnd.openxmlformats-officedocument.presentationml.presentation": "http://3-im.guokr.com/WVgOu_1nP8-MnaEufdH3IF1Z3bDygLsC3kE7mYO0y9XIAAAAyAAAAFBO.png",
    css: "http://3-im.guokr.com/f9HZySa2vn-f8BPS2zHRRjQH18Pvyclcq-wd8IqwwifIAAAAyAAAAFBO.png",
    doc: "http://2-im.guokr.com/UQLQ4sxqgU0IFjDqXyqYTyNCu-oKmtNyx9uUFywcx5DIAAAAyAAAAFBO.png",
    msword: "http://2-im.guokr.com/UQLQ4sxqgU0IFjDqXyqYTyNCu-oKmtNyx9uUFywcx5DIAAAAyAAAAFBO.png",
    excel: "http://1-im.guokr.com/EEEXz8z0qrzzSOEGRzTvDwRrRW5qVCRCyDvWRzcQzFPIAAAAyAAAAFBO.png",
    "vnd.openxmlformats-officedocument.spreadsheetml.sheet": "http://1-im.guokr.com/EEEXz8z0qrzzSOEGRzTvDwRrRW5qVCRCyDvWRzcQzFPIAAAAyAAAAFBO.png",
    pdf: "http://1-im.guokr.com/2-clfBVzlg0dsPv2CDuE-F5v9BnobjRCo5g9n-5_qIjIAAAAyAAAAFBO.png",
}

export const formatSize = (value: number) => {
    if (value === 0) {
        return 0
    }
    const unitArr = ["Bytes","KB","MB","GB","TB","PB","EB","ZB","YB"]
    const index = Math.floor(Math.log(value)/Math.log(1024))
    let size: string | number = value / Math.pow(1024, index)
    size = size.toFixed(2)
    return size + unitArr[index]
}

const checkType = (value: string) => {
    const [ type, extension ] = value.split("/")
    if (type === "application") {
        return extension
    } else {
        return type
    }
}

const AnnexItem = (props: ComponentProps) => {
    const { content_type, name, url, file_size, uploaded, onRemove,
    isUploading, percent, disabled } = props
    const classes = useAnnexItemStyles()
    const { show, handleMouseEnter, handleMouseLeave } = useMouseGesture()
    const contentType = checkType(content_type) as keyof AnnexIcon
    const { handleDownload } = useDownload()
    const canPreview = ["image", "audio", "video", "pdf"].indexOf(contentType) !== -1
    return (
        <Grid item className={classes.root} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
            <Grid container spacing={2} alignItems="center" justify="flex-start">
                <Grid item className={classes.itemWrap}>
                    <img
                        className={classes.imageIcon}
                        src={annexIconUrl[contentType] || annexIconUrl.unknown}
                        alt="图片"
                    />
                </Grid>
                <Grid item className={classes.itemWrap}>
                    <Typography
                        className={classes.textWrap}
                        color="textPrimary"
                        variant="body1"
                    >{name}</Typography>
                    <Typography
                        className={classes.textWrap}
                        color="textSecondary"
                        variant="body2"
                    >{formatSize(file_size)}</Typography>
                </Grid>
                {
                    show && !isUploading && (
                        <div className={classes.mask}>
                            {
                                uploaded && (
                                    <Fragment>
                                        <IconButton size="small" color="primary">
                                            <CloudDownload fontSize="small" onClick={() => {
                                                handleDownload(url, name)
                                            }}/>
                                        </IconButton>
                                        {
                                            canPreview && (
                                                <IconButton size="small" color="primary" onClick={() => {
                                                    window.open(url, "_blank")
                                                }}>
                                                    <Visibility fontSize="small" />
                                                </IconButton>
                                            )
                                        }
                                    </Fragment>
                                )
                            }
                            {
                                !disabled && (
                                    <IconButton size="small" color="secondary" onClick={onRemove}>
                                        <DeleteIcon fontSize="small" />
                                    </IconButton>
                                )
                            }
                        </div>
                    )
                }
                {
                    isUploading && (
                        <div className={classes.mask}>
                            <CircularProgress variant="determinate" value={percent} color="secondary" />
                        </div>
                    )
                }
            </Grid>
        </Grid>
    )
}

export default AnnexItem
